import { Injectable } from '@angular/core';
import { IPortaleContratti } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDPortaleContrattiStore } from './iidPortaleContratti.store';
import { IIDPortaleContrattiQuery } from './iidPortaleContratti.query';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.PORTALE_CONTRATTI)
export class IIDPortaleContrattiService extends CrudService<IPortaleContratti, IIDPortaleContrattiStore, IIDPortaleContrattiQuery> {
  constructor(
    protected store: IIDPortaleContrattiStore,
    public query: IIDPortaleContrattiQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy
  ) {
    super(Topics.IID_PORTALE_CONTRATTI, store, query, actionService, updateStrategy);
  }
}
